// src/components/PDF/OrdenPagoPDF.js

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

const generarOrdenPagoPDF = async (datos, logoBase64) => {
    return new Promise((resolve, reject) => {
        const doc = new jsPDF()
        const colorPrincipal = [0, 148, 202] // #0094CA
        const margen = 20
        const pageWidth = doc.internal.pageSize.getWidth()
        const pageHeight = doc.internal.pageSize.getHeight()

        // Badge de estatus
        let estatusTexto = ''
        let estatusColor = [200, 200, 200]

        switch (datos.estatus) {
            case 'XC': // Por pagar
                estatusTexto = 'POR PAGAR'
                estatusColor = [255, 165, 0]
                break
            case 'V': // Validando
                estatusTexto = 'VALIDANDO PAGO'
                estatusColor = [128, 0, 128] // naranja
                break
            case 'P': // Pagado
                estatusTexto = 'PAGADO'
                estatusColor = [0, 180, 0] // verde
                break
        }



        // Logo
        if (logoBase64) {
            const imgProps = doc.getImageProperties(logoBase64)
            const imgWidth = 35
            const imgHeight = (imgProps.height * imgWidth) / imgProps.width
            doc.addImage(logoBase64, 'PNG', margen, 35, imgWidth, imgHeight)
        }

        // Título
        doc.setFontSize(18)
        doc.setTextColor(...colorPrincipal)
        doc.text('ORDEN DE PAGO', pageWidth / 2, 20, { align: 'center' })

        // Línea decorativa
        doc.setDrawColor(...colorPrincipal)
        doc.setLineWidth(0.8)
        doc.line(margen, 25, pageWidth - margen, 25)



        if (estatusTexto) {
            const badgeWidth = doc.getTextWidth(estatusTexto) + 10
            const badgeHeight = 6
            const x = pageWidth - badgeWidth - margen
            const y = 30

            // Fondo del badge
            doc.setFillColor(...estatusColor)
            doc.roundedRect(x, y, badgeWidth, badgeHeight, 3, 3, 'F')

            // Texto del badge
            doc.setTextColor(255, 255, 255)
            doc.setFontSize(10)
            doc.setFont('helvetica', 'bold')
            doc.text(estatusTexto, x + badgeWidth / 2, y + 4.5, { align: 'center' })
            doc.setTextColor(0, 0, 0)
        }

        // Datos generales
        doc.setFontSize(12)
        doc.setTextColor(50, 50, 50)
        const lineHeight = 7
        let y = 42

        doc.text(`Folio: ${datos.folio}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight
        doc.text(`Fecha Máxima de Pago: ${datos.fechaMaxPago.split("T")[0]}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight
        doc.text(`Proveedor: ${datos.proveedor}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight
        doc.text(`RFC: ${datos.rfc}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight
        doc.text(`Método de pago: ${datos.metodoPago}`, pageWidth - margen, y, { align: 'right' }); y += lineHeight + 5

        // Tabla bancaria
        autoTable(doc, {
            startY: y,
            head: [['Banco', 'Cuenta', 'CLABE', 'Beneficiario']],
            body: [[datos.banco, datos.cuenta, datos.clabe, datos.beneficiario]],
            styles: { fontSize: 10, cellPadding: 3 },
            headStyles: {
                fillColor: colorPrincipal,
                textColor: 255,
                fontStyle: 'bold',
                halign: 'center'
            },
            theme: 'grid'
        })

        const tablaBancoY = doc.lastAutoTable.finalY + 10

        // Tabla de conceptos
        autoTable(doc, {
            startY: tablaBancoY,
            head: [['Cantidad', 'Descripción', 'Precio Unitario', 'Importe']],
            body: datos.conceptos.map(c => [
                c.cantidad,
                c.descripcion,
                c.precioUnitario,
                c.precioUnitario
            ]),
            styles: { fontSize: 10, cellPadding: 3 },
            headStyles: {
                fillColor: colorPrincipal,
                textColor: 255,
                halign: 'center',
                fontStyle: 'bold'
            },
            columnStyles: {
                0: { halign: 'center' },
                2: { halign: 'right' },
                3: { halign: 'right' }
            },
            theme: 'grid'
        })

        const tablaY = doc.lastAutoTable.finalY + 10

        // Total
        const total = datos.conceptos[0].precioUnitario
        autoTable(doc, {
            startY: tablaY,
            body: [['Total', `${total}`]],
            styles: { fontSize: 12, cellPadding: 4 },
            columnStyles: {
                0: { fontStyle: 'bold', halign: 'right' },
                1: { fontStyle: 'bold', halign: 'right' }
            },
            theme: 'grid'
        })

        // Datos adicionales
        let infoY = doc.lastAutoTable.finalY + 15
        doc.setFontSize(10)
        doc.setTextColor(80, 80, 80)
        doc.text('Datos de contacto', margen, infoY); infoY += 6
        doc.text(`Email: ${datos.email}`, margen, infoY); infoY += 5
        doc.text(`Teléfono: ${datos.telefono}`, margen, infoY); infoY += 8

        doc.text('Domicilio fiscal', margen, infoY); infoY += 6
        doc.text(
            `${datos.calle} ${datos.numeroExterior}${datos.numeroInterior ? ' Int. ' + datos.numeroInterior : ''}, Col. ${datos.colonia}`,
            margen, infoY
        ); infoY += 5
        doc.text(
            `${datos.municipio}, ${datos.estado}, ${datos.pais}, CP ${datos.cp}`,
            margen, infoY
        )

        // Footer
        const totalPages = doc.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i)
            const contactoStartY = pageHeight - 35

            doc.setDrawColor(...colorPrincipal)
            doc.setLineWidth(0.5)
            doc.line(20, contactoStartY, pageWidth - 20, contactoStartY)

            doc.setFontSize(8)
            doc.setTextColor(100, 100, 100)
            doc.text('Arrendafit - contacto@arrendafit.com - www.arrendafit.com', pageWidth / 2, contactoStartY + 8, { align: 'center' })

            doc.setFontSize(9)
            doc.text(`Página ${i} de ${totalPages}`, pageWidth - 20, pageHeight - 10, { align: 'right' })
        }

        const base64 = doc.output('datauristring')
        resolve(base64)
    })
}

export { generarOrdenPagoPDF }
